import script from "./legoPopover.vue?vue&type=script&lang=js"
export * from "./legoPopover.vue?vue&type=script&lang=js"

import "./legoPopover.vue?vue&type=style&index=0&id=63ba4c1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ba4c1d"],['__file',"src/components/lego/extend/legoPopover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ba4c1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ba4c1d', __exports__)) {
    api.reload('63ba4c1d', __exports__)
  }
  
}


export default __exports__